import { filter, findKey, forEach, indexOf, map, size, some } from 'lodash';
import React, { RefObject, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import styled, { css } from '../../themes/themed-styled-components';


//import './NavMenu.css';

//const NavMenu = (props) => {

//}

//export default NavMenu;

const MenuContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;
`;

const Menu = styled.ul`
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 0;
    margin: 0;
    max-width: 100%;
    overflow-x: hidden;
`;

const Overflow = styled.div`
`

type ItemAttrs = {
    $visible: boolean,
    $order: number
}

const invisibleItem = css`
    visibility: hidden;
    opacity: 0;
`

const Item = styled.li.attrs(({ $visible, $order }: ItemAttrs) => ({ $visible, $order }))`
    list-style-type: none;
    white-space: nowrap;
    padding: 5px;
    order: ${({ $order }) => $order};
    ${({ $visible }) => $visible ? null : invisibleItem}
`;

type OverflowItemAttrs = {
    padding: number
}

const OverflowItem = styled.li.attrs(({ padding }: OverflowItemAttrs) => ({ padding }))`
    list-style-type: none;
    visibility: hidden;
    padding-left: ${({ theme: { caretWidth } }) => caretWidth};
    transform: translate(calc(${({ padding }) => (-1 * padding)}px - ${({ theme: { caretWidth } }) => caretWidth}), 0);
    order: 1000;
    z-index: -1;
`;


export type HorizontalMenuItem = {
    key: string,
    important?: boolean,
    el: JSX.Element | string,
    overflowed?: JSX.Element | string
}

type HorizontalMenuProps = {
    items: HorizontalMenuItem[]
}

const HorizontalMenu = ({ items }: HorizontalMenuProps) => {
    const [visibleItemsCount, setVisibleItemsCount] = useState<number>(items.length);
    const elementsRef = useRef<Record<string, HTMLLIElement>>({});
    const itemsVisibilityRef = useRef<Record<string, boolean>>({});

    //const [overflowedItems, setOverflowedItems] = useState<MenuItem[]>([]);

    const [menu, setMenu] = useState<HTMLElement | null>(null);
    //const [itemsVisibility, setItemsVisibility] = useState<Record<string, boolean>>({});

    const [overflowWidth, setOverflowWidth] = useState<number>(0);
    const overflowItemRef = useRef<HTMLLIElement | null>(null);

    const overflowResizeObserver = useMemo(() => new ResizeObserver(([overflowEntry]: ResizeObserverEntry[]) => {
        console.log(overflowEntry);

        setOverflowWidth(overflowEntry.contentRect.width);
    }), [setOverflowWidth])

    const setOverflow = useCallback((overflow: HTMLElement | null) => {
        if (overflow === null) {
            setOverflowWidth(0);
            overflowResizeObserver.disconnect();
            return;
        }

        overflowResizeObserver.observe(overflow);

    }, [overflowResizeObserver, setOverflowWidth]);

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = useCallback(() => setDropdownOpen(dropdownOpen => !dropdownOpen), [setDropdownOpen]);

    const [observer, setObserver] = useState<IntersectionObserver | null>(null);

    const handleIntersection = useCallback<IntersectionObserverCallback>((entries: IntersectionObserverEntry[]) => {
        const elements = elementsRef.current;
        const itemsVisibility = itemsVisibilityRef.current;
        const overflowItem = overflowItemRef.current;
        let allVisible = false;
        const l = entries.length;
        let i = 0;

        for (i; i < l; i++) {
            const { target, intersectionRatio } = entries[i];

            if (target === overflowItem && intersectionRatio === 1) {
                allVisible = true;
                continue;
            }

            const key = findKey(elements, target);

            if (key === undefined) {
                continue;
            }

            itemsVisibility[key] = intersectionRatio === 1;
        }

        setVisibleItemsCount((allVisible as boolean) === true ? size(elements) : filter(itemsVisibility).length);
    }, [setVisibleItemsCount]);

    useEffect(() => {
        if (menu === null) {
            return;
        }

        setObserver(new IntersectionObserver(handleIntersection, {
            root: menu,
            threshold: [1],
            //rootMargin: `0px ${overflowedItems.length === 1 ? overflowWidth : 0}px 0px 0px`
        }));

    }, [menu, handleIntersection, overflowWidth]);

    useEffect(() => {
        if (observer === null) {
            return;
        }

        forEach(elementsRef.current, (el) => {
            observer.observe(el);
        });

        return () => {
            observer.disconnect();
        }
    }, [observer]);

    useEffect(() => {

        if (observer === null) {
            return;
        }

        const elements: typeof elementsRef.current = {};

        forEach(elementsRef.current, (el, key) => {
            if (some(items, { key })) {
                elements[key] = el;
                return;
            }
        });

        //if (observer === null || size(items) === 0) {
        //    return;
        //}

        //var items = map(items, ({ ref }) => ref.current)

        //forEach(items, (item) => {
        //    if (item === null) {
        //        return;
        //    }
        //    observer.observe(item);
        //});

        //return () => {
        //    forEach(items, (item) => {
        //        if (item === null) {
        //            return;
        //        }
        //        observer.unobserve(item);
        //    });
        //}
    }, [items, observer]);

    //useEffect(() => {
    //    const overflowed = filter(menuItems, ({ id }) => !(itemsVisibility[id] ?? false));
    //    setOverflowedItems(overflowed);

    //    if (overflowed.length === 0) {
    //        setOverflow(null);
    //    }
    //}, [menuItems, itemsVisibility, setOverflow])

    const setElement = useCallback((key: string) => (node: HTMLLIElement | null) => {

        const oldNode = elementsRef.current[key] ?? null;

        if (node === null || oldNode === node) {
            return;
        }

        elementsRef.current[key] = node;

        if (observer === null) {
            return;
        }

        observer.observe(node);

        if (oldNode !== null) {
            observer.unobserve(oldNode);
        }
    }, [observer]);

    const importantItemsCount = useMemo(() => filter(items, 'important').length, [items]);

    const [menuItems, overflowedItems] = useMemo(() => {
        const visibileNonImportantItemsCount = Math.max(visibleItemsCount - importantItemsCount, 0);
        const visibileImportantItemsCount = Math.min(visibleItemsCount, importantItemsCount);

        const menuItems: JSX.Element[] = [];
        const overflowedItems: HorizontalMenuItem[] = [];

        let i = 0;
        const l = items.length;
        let ic = 0;
        let inc = 0;

        for (i; i < l; i++) {
            const item = items[i];
            const { key, el, important } = item;
            const order = i < visibileNonImportantItemsCount + ic ? 1 : important === true ? 2 : 3;
            const visible = important ? ic++ < visibileImportantItemsCount : inc++ < (visibileNonImportantItemsCount);

            menuItems.push(<Item ref={setElement(key)} key={key} $order={order} $visible={visible}>{el}</Item>);

            if (visible === true) {
                continue;
            }

            overflowedItems.push(item);
        }

        return [menuItems, overflowedItems];
    }, [items, setElement, visibleItemsCount, importantItemsCount]);

    const overflowMenu = useMemo(() => {
        if (overflowedItems.length === 0) {
            return null;
        }

        return <Overflow ref={setOverflow}>
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret />
                <DropdownMenu right>
                    {map(overflowedItems, ({ key, el, overflowed }) => <DropdownItem key={key}>{overflowed ?? el}</DropdownItem>)}
                </DropdownMenu>
            </Dropdown>
        </Overflow>
    }, [overflowedItems, dropdownOpen, toggle, setOverflow])

    const setOverflowItemRef = useCallback((node: HTMLLIElement) => {
        const overflowItem = overflowItemRef.current;
        overflowItemRef.current = node

        if (overflowItem !== node && overflowItem !== null) {
            observer?.unobserve(overflowItem);
        }

        if (node !== null) {
            observer?.observe(node);
        }

    }, [observer])

    const visibleMenu = useMemo(() => <Menu ref={setMenu}>
        {menuItems}
        {overflowWidth === 0 ? null : <OverflowItem ref={setOverflowItemRef} padding={overflowWidth} />}
    </Menu>, [menuItems, setOverflowItemRef, overflowWidth])

    return <MenuContainer>
        {visibleMenu}
        {overflowMenu}
    </MenuContainer>
}

type useHorizontalMenuProps = {
    direction?: 'horizontal' | 'vertical',
    overflowRef: RefObject<Element | null>,
    count: number
}

export const useHorizontalMenu = ({ overflowRef, count, direction = 'horizontal' }: useHorizontalMenuProps) => {
    const [visibleItemsCount, setVisibleItemsCount] = useState<number>(0);

    const itemsRef = useRef<Array<Element | null>>(Array(count).map(() => null));
    const itemsVisibilityRef = useRef<Array<number>>(Array(count).map(() => 0));

    const [observer, setObserver] = useState<IntersectionObserver | null>(null);

    const handleIntersection = useCallback<IntersectionObserverCallback>((entries: IntersectionObserverEntry[]) => {
        const items = itemsRef.current;
        const itemsVisibility = itemsVisibilityRef.current;

        let allVisible = false;
        const l = entries.length;
        let i = 0;

        for (i; i < l; i++) {
            const { target, intersectionRatio } = entries[i];

            const index = indexOf(items, target);

            if (index < 0) {
                continue;
            }

            //itemsVisibility[index] = intersectionRatio === 0;
        }

        setVisibleItemsCount((allVisible as boolean) === true ? size(items) : filter(itemsVisibility).length);

    }, [setVisibleItemsCount]);

    useEffect(() => {
        const overflow = overflowRef.current;

        if (overflow === null) {
            return;
        }

        setObserver(new IntersectionObserver(handleIntersection, {
            root: overflow,
            threshold: [0, 1]
        }));

    }, [overflowRef.current, handleIntersection]);

    useEffect(() => {
        if (observer === null) {
            return;
        }

        const items = itemsRef.current;
        const l = items.length;
        let i = 0;

        for (i; i < l; i++) {
            const item = items[i];

            if (item === null) {
                continue;
            }
            observer.observe(item);
        }

        return () => {
            observer.disconnect();
        }
    }, [observer]);

    //useEffect(() => {
    //    const overflowed = filter(menuItems, ({ id }) => !(itemsVisibility[id] ?? false));
    //    setOverflowedItems(overflowed);

    //    if (overflowed.length === 0) {
    //        setOverflow(null);
    //    }
    //}, [menuItems, itemsVisibility, setOverflow])

    const getItemRef = useCallback((i: number) => (node: Element | null) => {

        const oldNode = itemsRef.current[i] ?? null;

        if (node === null || oldNode === node) {
            return;
        }

        itemsRef.current[i] = node;

        if (observer === null) {
            return;
        }

        if (oldNode !== null) {
            observer.unobserve(oldNode);
        }

        observer.observe(node);
    }, [observer]);

    return {
        refs: itemsRef.current.map((item, i) => getItemRef(i)),
        visibleItemsCount
    };
}
export default HorizontalMenu;
